import { Navigate } from "react-router-dom";
import { ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({
  children,
  ownerOnly,
}: {
  children: ReactNode;
  ownerOnly?: boolean;
}) {
  const { user, isAuthLoading, isDashboardOwner } = useAuth();

  if (isAuthLoading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="h-10 w-10 rounded-full border-4 border-primary/30 border-t-primary animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (ownerOnly && !isDashboardOwner) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
